// extracted by mini-css-extract-plugin
module.exports = {"affirmMessage":"AffirmMessageA_affirmMessage__2bOYE"};